import axios from 'axios'
import { useCallback, useEffect, useState } from 'react'

import { AresEkonomickySubjekt } from '../../common/aresTypes'
import { AsyncState } from '../../redux/fetchAction'

export const useFetchAresIco = (ico?: string) => {
  const [state, setState] = useState<AsyncState<AresEkonomickySubjekt>>({
    fetching: true,
    data: null,
    error: false,
  })

  const fetchSubjectAreaSummary = useCallback(async () => {
    if (!ico) {
      setState({
        fetching: false,
        data: null,
        error: true,
      })
      return
    }

    setState({
      fetching: true,
      data: null,
      error: false,
    })

    try {
      const response = await axios.get(
        `https://ares.gov.cz/ekonomicke-subjekty-v-be/rest/ekonomicke-subjekty/${ico}`
      )

      setState({
        fetching: false,
        data: response.data,
        error: false,
      })
    } catch (error) {
      setState({
        fetching: false,
        data: null,
        error: true,
      })
    }
  }, [ico])

  useEffect(() => {
    fetchSubjectAreaSummary()
  }, [fetchSubjectAreaSummary])

  return state
}
